export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-100 border border-background-200/40 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <div className="flex items-center gap-3 mb-3 justify-center lg:justify-start">
                <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">移动端观影</h2>
              </div>
              <p className="text-sm md:text-base text-foreground-200 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                桃子影院已全面适配移动端浏览器，无需下载APP，打开手机浏览器即可畅享高清超清蓝光4K影视。自适应屏幕尺寸，横竖屏自由切换，通勤路上、午休间隙、睡前时光，随时随地秒开观影。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-200/60 border border-background-300/40">
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-smartphone-line text-primary-400 text-xl"></i>
                  </span>
                  <div className="text-left">
                    <div className="text-xs text-foreground-400">手机访问</div>
                    <div className="text-sm font-semibold text-foreground-50">m.taozicinema.com</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-200/60 border border-background-300/40">
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-qr-code-line text-accent-400 text-xl"></i>
                  </span>
                  <div className="text-left">
                    <div className="text-xs text-foreground-400">扫码直达</div>
                    <div className="text-sm font-semibold text-foreground-50">手机扫码观影</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-[200px] h-[400px] md:w-[220px] md:h-[440px] rounded-[2rem] border-4 border-background-300/50 overflow-hidden bg-background-200">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-background-300 rounded-b-xl z-10"></div>
                <div className="w-full h-full pt-8 pb-2 px-2 flex flex-col gap-1.5">
                  <div className="flex-1 rounded-lg bg-background-300/50 flex items-center justify-center">
                    <div className="text-center">
                      <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/20 mx-auto mb-2">
                        <i className="ri-movie-2-line text-primary-400 text-xl"></i>
                      </span>
                      <div className="text-[10px] text-foreground-400">桃子影院</div>
                      <div className="text-[11px] font-bold text-primary-400 mt-1">秒开观影</div>
                    </div>
                  </div>
                  <div className="h-8 rounded-lg bg-background-300/40 flex items-center justify-center">
                    <div className="flex gap-3">
                      <span className="w-4 h-4 rounded bg-primary-500/40"></span>
                      <span className="w-4 h-4 rounded bg-background-400/40"></span>
                      <span className="w-4 h-4 rounded bg-background-400/40"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}